import render from './render-mustache.js';

// Hide toast
const hideToast = (component) => {
    component.classList.remove('show');
    component.classList.add('hide');
}

// Show toast
const showToast = (component) => {
    component.classList.remove('hide');
    component.classList.add('show');
}

export const Toast = (container, props) => {
    let component = document.querySelector('#liveToast') || null;
    // Check if the is no existing Toast already in the DOM
    if (!component) {
        const template = `
            <div class="position-fixed bottom-0 right-0 p-3" style="z-index: 5; right: 0; bottom: 0;">
                <div id="liveToast" class="toast show bg-danger" role="alert" aria-live="assertive" aria-atomic="true" data-delay="2000">
                    <div class="toast-header">
                        <strong class="mr-auto">Unsuccesful</strong>
                        <button id="toast_close" type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="toast-body text-light">
                        {{message}}
                    </div>
                </div>
            </div>
        `;
        render(container, 'appendTemplate', template, { message: props.message });
        // Assign the rendered template to component

        component = document.querySelector('#liveToast');
        // Add event listener to the close button o the toast
        document.getElementById('toast_close').addEventListener('click', () => {
            hideToast(component);
        });
        // Hide toast after 3 seconds
        setTimeout(() => hideToast(component), 3000);
    } else {
        // Only change the message
        showToast(component);
        // Hide toast after 3 seconds
        setTimeout(() => hideToast(component), 3000);
    }
}


export default Toast;